module.exports = __webpack_public_path__ + "assets/img/block-left-348ee03c.png";